import { render, staticRenderFns } from "./FaturamentoPrincipaisClientes.vue?vue&type=template&id=64671469&scoped=true&"
import script from "./FaturamentoPrincipaisClientes.vue?vue&type=script&lang=js&"
export * from "./FaturamentoPrincipaisClientes.vue?vue&type=script&lang=js&"
import style0 from "./FaturamentoPrincipaisClientes.vue?vue&type=style&index=0&id=64671469&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64671469",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
